import get from "lodash/get";

const helpers = {
  get(o, path, defaultValue) {
    return get(o, path, defaultValue);
  },
};

export function alias(path, method, defaultValue) {
  return {
    [method]() {
      return helpers.get(this, path, defaultValue);
    },
  };
}

export default helpers;
